<template>
  <main>
    <div class="details-service">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{$t('title.detailsService')}}{{ referenceName }}</h3>
            </template>

            <template v-slot:right-element>
              <div class="d-flex buttons-wrapper">
                <router-link
                  :to="{ name: 'ServiceList' }"
                  class="btn btn-outline-primary button"
                  :disabled="loading"
                >
                  <i class="arrow left"></i>
                  {{ $t('button.retour') }}
                </router-link>
                <router-link
                  :to="{
                    name: 'AddPrix',
                    params: { id: referenceId },
                  }"
                  class="btn button btn-primary"
                >
                  <i class="icon-Add"></i>
                  {{ $t('button.addPrice') }}
                </router-link>
              </div>
            </template>
          </TopTemplate>
        </div>
      </div>
    </div>

    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-if="!loading && reference" class="table service-list row">
      <div class="col-md-12">
        <h3>{{ $t('title.priceService') }}</h3>
        <div class="table__wrapper">
          <table>
            <thead>
              <tr>
                <th class="message eleve" @click="sortB('created_at')">
                  {{ $t('service.form.date') }}
                  <div class="icon-wrapper">
                    <i
                      class="ri-arrow-up-s-line"
                      :class="[specTri('created_at', true)]"
                      @click="sort(false, 'created_at')"
                    />
                    <i
                      class="ri-arrow-down-s-line"
                      :class="[specTri('created_at', false)]"
                      @click="sort(true, 'created_at')"
                    />
                  </div>
                </th>
                <th class="envle order-from espace_width" @click="sortB('created_at')">
                  {{ $t('service.anneeScolaire') }}
                  <div class="icon-wrapper">
                    <i
                      class="ri-arrow-up-s-line"
                      :class="[specTri('created_at', true)]"
                      @click="sort(false, 'created_at')"
                    />
                    <i
                      class="ri-arrow-down-s-line"
                      :class="[specTri('created_at', false)]"
                      @click="sort(true, 'created_at')"
                    />
                  </div>
                </th>
                <th class="envle order-from date" @click="sortB('created_at')">
                  {{ $t('service.price') }}
                  <div class="icon-wrapper">
                    <i
                      class="ri-arrow-up-s-line"
                      :class="[specTri('created_at', true)]"
                      @click="sort(false, 'created_at')"
                    />
                    <i
                      class="ri-arrow-down-s-line"
                      :class="[specTri('created_at', false)]"
                      @click="sort(true, 'created_at')"
                    />
                  </div>
                </th>
                <th class="envle order-from" @click="sortB('created_at')">
                  {{ $t('service.status') }}
                  <div class="icon-wrapper">
                    <i
                      class="ri-arrow-up-s-line"
                      :class="[specTri('created_at', true)]"
                      @click="sort(false, 'created_at')"
                    />
                    <i
                      class="ri-arrow-down-s-line"
                      :class="[specTri('created_at', false)]"
                      @click="sort(true, 'created_at')"
                    />
                  </div>
                </th>
              </tr>
            </thead>

            <tbody v-for="ref in reference" :key="ref.id">
              <tr v-if="ref.price.length === 0">
                <td>{{  moment(ref.date_start).format("DD-MM-YYYY")}}</td>
                <td>__</td>
                <td>__</td>
                <td><span class="noActive_status">{{ $t('common.noActive') }}</span></td>
              </tr>
              <tr v-else v-for="refPrice in ref.price" :key="refPrice.id">
                <td>{{ moment(refPrice.date_start).format("DD-MM-YYYY") }}</td>
                <td>{{ refPrice.school_year }}</td>
                <td>{{ refPrice.price.toFixed(3) }}</td>
              
                <td>
                  <span class="active_status" v-if="refPrice.is_current_price"
                    >{{ $t('common.active') }}</span
                  ><span class="noActive_status" v-else>{{ $t('common.noActive') }}</span>
                </td>
                </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
    <div v-if="!loading" class="container-fluid service-list mois">
        <div class>
          <h3>{{ $t('service.form.mois') }}</h3>
          <div class="row items-wrapper">
            <div
              v-for="(mois,index) in listMois(months)"
              :key="index"
              class="col-xl-2 col-lg-3 col-md-3 col-sm-5 col-xs-12"
            >
              <div
                class="matiere-item"
                :class="mois.status === 1 ? 'matiere-background' : ''"
              >
                <span>{{ mois.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import ServicesService from "../../services/services.service";
import moment from "moment";
import _ from "lodash";

export default {
  name: "DetailsService",
  components: {
    TopTemplate,
  },
  data() {
    return {
      list_Mois: [
          {
            name: "Janvier",
            status: 0,
            is_checked : false
          },
          {
            name: "Février",
            status: 0,
            is_checked : false
          },
          {
            name: "Mars",
            status: 0,
            is_checked : false
          },
          {
            name: "Avril",
            status: 0,
            is_checked : false
          },
          {
            name: "Mai",
            status: 0,
            is_checked : false
          },
          {
            name: "Juin",
            status: 0,
            is_checked : false
          },
          {
            name: "Juillet",
            status: 0,
            is_checked : false
          },
          {
            name: "Août",
            status: 0,
            is_checked : false
          },
          {
            name: "Septembre",
            status: 0,
            is_checked : false
          },
          {
            name: "October",
            status: 0,
            is_checked : false
          },
          {
            name: "November",
            status: 0,
            is_checked : false
          },
          {
            name: "Décembre",
            status: 0,
            is_checked : false
          },
        ],
      referenceId: null,
      reference: {},
      referenceName: "",
      moment:null,
      months:[],
      loading: false,
      params: {
        q: "",
        limit: 7,
        page: 1,
        sort: "price.created_at",
        order: false,
      },
    };
  },
  created() {
    this.referenceId = this.$route.params.id;
  
    this.moment = moment;
  },
  mounted() {
    this.getDetails();
  },

  methods: {
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListServices();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListServices();
    },
    getDetails() {
      this.loading = true;
      ServicesService.getPrice(this.referenceId, {
        params: {
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
        },
      })
        .then((response) => {
          this.referenceName = response.data.data.name;
          this.reference = response.data;
          this.months=this.reference.data.months;
          this.reference.data.price = _.orderBy(this.reference.data.price , "created_at","desc");
          this.loading = false;
        })
        .catch((error) => {
           if (error.response && error.response.status === 404) {
              this.$router.push('/error-404');
            }
        });
    },
    listMois(data){
      this.list_Mois.forEach(((el,index)=>{
       if(data[index] === 1) {
        this.list_Mois[index].status = 1
       }
      }))
      return this.list_Mois
    }
  },
};
</script>
<style scoped>
.mois {
margin-top:20px}
.service-list {
  margin-left: 0 !important;
}
.service-list .table__wrapper{
  padding:0
}
</style>
